import { Box, Grid } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { LoadingButton } from "@mui/lab";
import FormikControl from "../FormikControl";
import { useDispatch, useSelector } from "react-redux";
import { createOutbondShipement, createShipement, selectVienToVienLoading } from "../../../slices/logisticSlice";
import { useParams } from "react-router";
import { selectCurrentCycle } from "../../../slices/common";

const initialValues = {
  delivery_partner_id: "",
  awb: "",
};

const validationSchema = Yup.object().shape({
  delivery_partner_id: Yup.string().required("Delivery Partner is required"),
  awb: Yup.string()
    .required("AWB Number is required")
    .max(150, "Maximum of 150 characters"),
  tracking_link: Yup.string()
    .url("Tracking Link must be a valid URL")
    .nullable()
    .notRequired()
    .test(
      "is-empty-or-valid-url",
      "Tracking Link must be a valid URL",
      (value) => !value || Yup.string().url().isValidSync(value)
    ),
});


const deliveryPartnerOptions = [
  {
    label: "EKart",
    value: 1,
  },
  {
    label: "Fedex",
    value: 2,
  },
  {
    label: "Delhivery",
    value: 3,
  },
  {
    label: "Blue Dart",
    value: 4,
  },
  {
    label: "In House",
    value: 5,
  },
];

const formOptions = [
  {
    type: "select",
    label: "Delivery Partner",
    name: "delivery_partner_id",
    options: deliveryPartnerOptions,
    required: true,
    placeholder: "Select partner",
  },
  {
    label: "AWB Number",
    type: "text",
    name: "awb",
    required: true,
    placeholder: "Enter AWB number",
  },
  {
    label: "Tracking Link",
    type: "text",
    name: "tracking_link",
    required: false,
    placeholder: "Enter Tracking Link",
  },
];
const MarkAsShippedForm = ({ stepSlug, handleFormSubmit = () => { } }) => {
  const dispatch = useDispatch();
  const vienToVienLoading = useSelector(selectVienToVienLoading)
  const { feasibilityId } = useParams();
  const currentCycle = useSelector(selectCurrentCycle)
  const handleSubmit = async (values) => {
    try {
      if (stepSlug == "product-shipped") {
        const res = await dispatch(
          createOutbondShipement({
            ...values,
            status: 0,
            feasibility_assessments_id: currentCycle?.feasibility_assessments_id ? currentCycle?.feasibility_assessments_id :+feasibilityId,
            product_manufacturing_id: currentCycle?.product_manufacturing_id,
          })
        ).unwrap();
        if (res.status === 200) {
          handleFormSubmit();
        }
      }
      else {
        const res = await dispatch(
          createShipement({
            ...values,
            status: 0,
            feasibility_assessments_id: currentCycle?.feasibility_assessments_id ? currentCycle?.feasibility_assessments_id :+feasibilityId,
          })
        ).unwrap();
        if (res.status === 200) {
          handleFormSubmit();
        }
      }

    } catch (err) {
      console.error(err);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit,
  });

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} className="mb-3">
          {formOptions.map((props, key) => (
            <Grid key={key} item xs={12}>
              <FormikControl formik={formik} {...props} />
            </Grid>
          ))}
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <LoadingButton loading={vienToVienLoading} fullWidth type="submit" variant="contained">
              Submit
            </LoadingButton>
          </Grid>
        </Grid>
      </form>
    </Box>
  );
};

export default MarkAsShippedForm;
